import React, { useRef, useState, useEffect } from 'react';
import Navbar from './Navbar';
import "./work.css";
// import Projects from './Projects';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import Slider from "react-slick";
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import BounceLoader from "react-spinners/BounceLoader";
import { gsap } from "gsap";
import Footer from './Footer';
import PulseLoader from "react-spinners/PulseLoader";
import { Box, Button, FormControl, Grid, IconButton, InputLabel, List, ListItem, ListItemIcon, ListItemText, MenuItem, Select, Skeleton, Stack, Typography, colors } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import { ThemeProvider } from "@mui/material/styles";
import theme from './theme';
import CloseIcon from '@mui/icons-material/Close';
import { NavLink } from 'react-router-dom';
import CategoryIcon from '@mui/icons-material/Category';
import DateRangeIcon from '@mui/icons-material/DateRange';
import LanguageIcon from '@mui/icons-material/Language';
import GitHubIcon from '@mui/icons-material/GitHub';
import LayersIcon from '@mui/icons-material/Layers';
import InfoIcon from '@mui/icons-material/Info';
import PhoneAndroidIcon from '@mui/icons-material/PhoneAndroid';
import PersonIcon from '@mui/icons-material/Person';
import axios from 'axios';


const Work = () => {
    // const baseURL = "https://my-portfolio-5u5m.onrender.com/"
    // const baseURL = "http://16.171.64.77/" this is aws ip
    // const baseURL = "";

    const wheelRef = useRef();
    const [allProjects, setAllProjects] = useState([])
    const [filteredProjects, setFilteredProjects] = useState([])
    const [allCategories, setAllCategories] = useState([])
    const [slideNumber, setSlideNumber] = useState(0);
    const [isMoved, setIsMoved] = useState(false);
    const [IsPlayPreview, setIsPlayPreview] = useState(false);
    const [isShowDetail, setisShowDetail] = useState(false);
    const [isMovedRight, setIsMovedRight] = useState(true);
    const [hoverId, sethoverId] = useState();
    const [clickedId, setclickedId] = useState();
    const [closeDetailBox, setcloseDetailBox] = useState();
    const [opengallery, setopengallery] = useState(false);
    const [playBigTrailer, setplayBigTrailer] = useState(false);
    const [displayImg, setdisplayImg] = useState();
    const [galleryArr, setgalleryArr] = useState([]);
    const [finalRightClick, setfinalRightClick] = useState(0);
    const [projectNumbers, setprojectNumbers] = useState(5);
    const [HideMore, setHideMore] = useState(false);
    const [ImageLoader, setImageLoader] = useState(true);
    const [showProject, setShowProject] = useState(false);
    const [projectClicked, setprojectClicked] = useState({});
    const [PhnProDetails, setPhnProDetails] = useState();
    const [projectFilterValue, setProjectFilterValue] = useState("all")
    const [loading, setLoading] = useState(true);
    const [loadingCategories, setLoadingCategories] = useState(true);
    const [isImageLoading, setisImageLoading] = useState(true);
    const [isProjectPreviewLoading, setisProjectPreviewLoading] = useState(true)
    const [projectVidUrl, setProjectVidUrl] = useState('')
    const [projectThumbUrl, setProjectThumbUrl] = useState('')
    const [imageLoading, setImageLoading] = useState([]);

    const el = useRef();
    const q = gsap.utils.selector(el);

    const listRef = useRef();
    const mainRef = useRef();
    let counter = 0;

    useEffect(() => {
        document.title = "Portfolio"
    }, [])

    useEffect(() => {

        window.onscroll = function () {
            wheelRef.current.style.transform = "rotate(" + window.pageYOffset / 2 + "deg)";
        };
    }, [])

    useEffect(() => {
        // const reqURL = `${baseURL}api/portfolio/projects/`
        const reqURL = `/api/portfolio/projects/`; //this is for proxy url for aws

        axios.get(reqURL)
            .then(res => {
                setAllProjects(res.data)
                // console.log(res.data)
                setLoading(false);

                setImageLoading(res.data.map(() => true));
            })
            .catch(error => {
                console.log(error)
            })
    }, [])

    useEffect(() => {
        // const reqURL = `${baseURL}api/portfolio/project-categories/`
        const reqURL = `/api/portfolio/project-categories/`

        axios.get(reqURL)
            .then(res => {
                setAllCategories(res.data)
                setLoadingCategories(false);
            })
            .catch(error => {
                console.log(error)
            })
    }, [])


    useEffect(() => {
        if (allProjects.length > 0) {
            const filteredProjects = allProjects.filter((project) => {
                if (projectFilterValue === "all") {
                    return true
                }
                else {
                    return project.category.includes(projectFilterValue)
                }
            })
            setFilteredProjects(filteredProjects)
        }
    }, [projectFilterValue, loading])

    var settings = {
        dots: false,
        infinite: true,
        speed: 600,
        slidesToShow: 1,
        slidesToScroll: 1,
        adaptiveHeight: true,
        fade: true
    };

    const imageLoaded = () => {
        const showImg = {
            opacity: 1,
            transition: "all 0.3s ease-in-out"
        }

        setTimeout(() => {
            setImageLoader(false)
            setdisplayImg(showImg)
        }, 300);
    }

    const openGallery = (galleryPics) => {

        const hideImg = {
            opacity: 0
        }
        setdisplayImg(hideImg)

        setopengallery(true)
        setgalleryArr(galleryPics)

        // setplayBigTrailer(false)
    }

    const [hideLoader, setHideLoader] = useState(false)

    useEffect(() => {

        if (!loading) {
            setHideLoader(true)
        }

    }, [loading])

    useEffect(() => {

        const t4 = gsap.timeline()

        t4
            .from(q(".container .listItem"), {
                opacity: 0,
                y: -100,
                duration: 0.1,
                stagger: 0.1,
                ease: "back.out(1.7)"
            }, 1)

        return () => {
            t4.kill();
        };
    }, []);


    const showMore = () => {
        setprojectNumbers(projectNumbers + 5)

    }

    useEffect(() => {
        if (filteredProjects.length > 0) {
            if (projectNumbers >= filteredProjects.length) {
                setHideMore(true)
            }
            else {
                setHideMore(false)
            }
        }
    }, [projectNumbers, filteredProjects])

    useEffect(() => {
        setprojectNumbers(5)
    }, [filteredProjects])



    const falsefunc = () => {
        setopengallery(false)
        setImageLoader(true)
    }

    const openingProject = (projectOpen, projectId) => {

        if (projectOpen.projectPreviewVideo) {
            const vidIpRemoveUrl = new URL(projectOpen.projectPreviewVideo).pathname
            const vidRedUrl = '/redapi' + vidIpRemoveUrl
            setProjectVidUrl(vidRedUrl)
        }
        else {
            const thumbIpRemovedUrl = new URL(projectOpen.thumbPoster).pathname
            const thumbRedUrl = '/redapi' + thumbIpRemovedUrl
            setProjectThumbUrl(thumbRedUrl)
        }


        setShowProject(true)
        setclickedId(projectId)
        setprojectClicked(projectOpen)
        setisProjectPreviewLoading(true)
    }

    const closeProject = () => {
        setShowProject(false)
        setprojectClicked({})
    }

    const handleImageLoad = (index) => {
        // Mark the corresponding image as loaded
        setImageLoading((prevLoading) => {
            const updatedLoading = [...prevLoading];
            updatedLoading[index] = false;
            return updatedLoading;
        });
    };

    return (
        <>
            <ThemeProvider theme={theme}>

                <div className="preloader" style={{ width: "100%", height: "100vh", background: "black", position: "fixed", top: "0", zIndex: "9999999", opacity: hideLoader && 0, visibility: hideLoader && "hidden", transition: "all 0.5s ease-in-out", display: "flex", justifyContent: "center", alignItems: "center" }}>
                    <BounceLoader color="#ff792e" size={100} />
                </div>
                <div ref={mainRef} className="mainCover" style={{ opacity: hideLoader && 1, transition: "all 0.5s ease-in-out" }}>
                    <Navbar workRef={mainRef} textcolor="rgb(252, 246, 244)" />

                    <section ref={el} className="work">
                        <h1 className="workBGHeading">Works</h1>

                        <div className="listContainer">
                            <div className="list">
                                <div className="WorkmainHeading">
                                    <h1>My Works</h1>
                                    <div className="underline">
                                        <span className="circle"></span>
                                        <span className="line"></span>
                                    </div>
                                </div>
                                <Grid container sx={{ justifyContent: { xs: "left", md: "center" }, mb: { xs: 3, md: 12 }, mt: { xs: 3, md: -3 } }} alignItems='center' mt={-3} position='relative' zIndex={9}>
                                    <Grid item xs={6} md={10}>
                                        <Stack direction='row' spacing={5} justifyContent='center' sx={{ display: { xs: "none", md: "flex" } }}>
                                            <Button onClick={() => setProjectFilterValue("all")} sx={{ borderRadius: 0, fontWeight: 600 }}
                                                variant={projectFilterValue == "all" ? 'contained' : 'outlined'} >
                                                All
                                            </Button>
                                            {
                                                allCategories.map((category) => {
                                                    return (
                                                        <Button key={category.id} onClick={() => setProjectFilterValue(category.category_name)} sx={{ borderRadius: 0, fontWeight: 600 }}
                                                            variant={projectFilterValue == category.category_name ? 'contained' : 'outlined'}>{category.category_name}</Button>
                                                    )
                                                })
                                            }
                                        </Stack>
                                        <FormControl sx={{ width: "100%", ml: 2, display: { xs: "inline-flex", md: "none" } }}>
                                            <InputLabel id="demo-simple-select-label" sx={{ color: "white" }}>Filter Projects</InputLabel>
                                            <Select
                                                labelId="demo-simple-select-label"
                                                id="demo-simple-select"
                                                value={projectFilterValue}
                                                label="Filter Projects"
                                                onChange={(event) => setProjectFilterValue(event.target.value)}
                                                MenuProps={{
                                                    PaperProps: {
                                                        style: {
                                                            background: "#000000eb",
                                                            backdropFilter: "blur(5px)",
                                                            color: "#ffffffe0",
                                                        },
                                                    },
                                                }}
                                                sx={{
                                                    color: "white",
                                                    '& .MuiOutlinedInput-notchedOutline': {
                                                        borderColor: 'white', // Change border color to white
                                                    },
                                                    '&:before': {
                                                        borderColor: 'white !important',
                                                    },
                                                    '&:after': {
                                                        borderColor: 'white !important',
                                                    },
                                                    '& svg': {
                                                        color: 'white !important',
                                                    },
                                                }}
                                            >
                                                <MenuItem value="all" sx={{ borderBottom: "1px solid  #ffffff30" }}>All</MenuItem>
                                                {
                                                    allCategories.map((category, index) => {
                                                        return (
                                                            <MenuItem sx={{ borderBottom: index < allCategories.length - 1 && "1px solid  #ffffff30" }} key={category.id} value={category.category_name}>{category.category_name}</MenuItem>
                                                        )
                                                    })
                                                }
                                            </Select>
                                        </FormControl>
                                    </Grid>
                                </Grid>
                                <Grid container sx={{ position: "relative", zIndex: 9, display: { xs: "none", md: "flex" } }} justifyContent='center'>
                                    <Grid item md={10}>
                                        <Grid container justifyContent='start' alignItems="flex-start" gap={5}>


                                            {
                                                filteredProjects.map((project, index) => {

                                                    let rows = Math.ceil(filteredProjects.length / 3)
                                                    let projectInd = index + 1
                                                    let projectRow = Math.ceil(projectInd / 3)
                                                    const techStack = project.tools.split(",")

                                                    const projectZIndex = rows - (projectRow - 1)

                                                    // console.log(project)
                                                    const ipRemovedUrl = new URL(project.thumbPoster).pathname
                                                    const redUrl = '/redapi' + ipRemovedUrl

                                                    // console.log(redUrl)
                                                    // console.log(vidIpRemoveUrl)

                                                    return (
                                                        <Grid key={project.id} item md={3.73343} position='relative' height="16em" mb={5}>
                                                            {
                                                                <>
                                                                    <Skeleton sx={{ display: (loading || imageLoading[index]) ? "block" : "none", bgcolor: "#2F2F2F", borderRadius: "12px" }} variant="rounded" width="100%" height='100%' />
                                                                    <Box bgcolor='#2F2F2F' sx={{
                                                                        display: (loading || imageLoading[index]) ? "none" : "block",
                                                                        borderRadius: "12px",
                                                                        p: 2,
                                                                        // height: "100%",
                                                                        // overflow: 'hidden',
                                                                        transition: "all 0.3s ease, height 0.3s ease-in-out 0.5s",
                                                                        position: "absolute",
                                                                        zIndex: projectZIndex,
                                                                        boxShadow: "10px 22px 52px 1px rgba(0,0,0,0.73)",
                                                                        "&:hover": {
                                                                            transform: "scale(0.98)",
                                                                            boxShadow: "10px 22px 52px 1px rgba(0,0,0,0.73)",
                                                                            // height: "auto",
                                                                        },
                                                                        "&:hover .projectImgBox": {
                                                                            transform: "translateY(-30%)",
                                                                            boxShadow: "5px 5px 51px 5px rgba(0,0,0,0.63)",
                                                                            margin: "0 auto"
                                                                        },
                                                                        "&:hover .techStack": {
                                                                            mt: "-3%",
                                                                            opacity: 1
                                                                        },
                                                                        "&:hover .projTitle": {
                                                                            fontSize: "1.5vw"
                                                                        },
                                                                        "&:hover .prodDesc": {
                                                                            height: "34%",
                                                                            overflow: 'hidden',
                                                                            opacity: 1,
                                                                            visibility: "visible",
                                                                            // mb: 0,
                                                                            display: "block",
                                                                            transition: "margin 0.3s ease-in-out 0s, opacity 0.3s ease-in-out 1s, visibility 0.3s ease-in-out 1s",

                                                                        },

                                                                    }} >
                                                                        <Box
                                                                            className='projectImgBox'
                                                                            display="flex"
                                                                            alignItems="center"
                                                                            width="100%"
                                                                            sx={{
                                                                                overflow: 'hidden',
                                                                                borderRadius: "12px",
                                                                                // height: "170px",
                                                                                margin: "0 auto",
                                                                                position: "relative",
                                                                                zIndex: 2,
                                                                                transition: "all 0.3s ease",
                                                                            }}>
                                                                            <img className='projectImg'
                                                                                onLoad={() => handleImageLoad(index)}
                                                                                style={{
                                                                                    width: "100%",
                                                                                    height: "100%",
                                                                                    transition: "transform 0.3s ease"
                                                                                }} src={redUrl}
                                                                                alt=""
                                                                            />
                                                                        </Box>
                                                                        <Box className='techStack' sx={{ mt: "-7%", opacity: 0, zIndex: 1, position: 'relative', transition: "all 0.3s ease" }}>
                                                                            <Stack direction='row' spacing={2} justifyContent='center' color="#FF792E">
                                                                                {
                                                                                    techStack.slice(0, 3).map((tech, index) => {

                                                                                        return <Typography sx={{
                                                                                            textOverflow: "ellipsis",
                                                                                            overflow: "hidden",
                                                                                            whiteSpace: "nowrap",
                                                                                        }}
                                                                                            key={index} >{tech}
                                                                                        </Typography>
                                                                                    })
                                                                                }
                                                                            </Stack>
                                                                        </Box>
                                                                        <Box textAlign='center' pt={2} >
                                                                            <Typography className='projTitle' sx={{
                                                                                color: "#dcdcdc",
                                                                                fontWeight: 700,
                                                                                textShadow: "0 1px 1px rgb(0 0 0 / 70%)",
                                                                                fontSize: "1.6vw",
                                                                                textOverflow: "ellipsis",
                                                                                overflow: "hidden",
                                                                                whiteSpace: "nowrap",
                                                                                cursor: "context-menu",
                                                                                transition: "all 0.3s ease-in-out 0s",
                                                                            }} variant='subtitle1'>{project.title}</Typography>
                                                                        </Box>
                                                                        <Box className='prodDesc' sx={{ display: "none", mt: 1, opacity: 0, visibility: "hidden", overflow: 'hidden', transition: "margin 0.3s ease-in-out 0.1s, opacity 0.3s ease-in-out 0s, visibility 0.3s ease-in-out 0s", mt: 1 }}>
                                                                            <Box textAlign='center'>
                                                                                <Typography sx={{ color: "#d2d2d2", fontSize: "15px" }} variant="body1" >{project.desciption.slice(0, 110) + "..."}</Typography>
                                                                            </Box>
                                                                            <Box textAlign='center' mt={2.5} mb={2}>
                                                                                <Button onClick={() => openingProject(project, project.id)} endIcon={<AddIcon />} sx={{ borderRadius: 0 }} variant="outlined">More Info</Button>
                                                                            </Box>
                                                                        </Box>

                                                                    </Box>
                                                                </>
                                                            }


                                                        </Grid>
                                                    )
                                                })
                                            }
                                        </Grid>
                                    </Grid>
                                </Grid>

                                {/* =========================================================================project decripton dialouge====================================== */}

                                <Grid container sx={{
                                    transition: "all 0.3s ease-in-out 0s",
                                    justifyContent: "center",
                                    width: "100vw",
                                    height: "100vh",
                                    opacity: showProject ? 1 : 0,
                                    visibility: showProject ? "visible" : "hidden",
                                    bgcolor: "#00000040",
                                    backdropFilter: "blur(5px)",
                                    position: "fixed",
                                    top: 0,
                                    left: 0,
                                    zIndex: 999,
                                    pt: 4,
                                    overflowY: "scroll"
                                }}>
                                    <Grid item md={7} bgcolor="#181818" borderRadius="12px" height='auto' overflow='hidden' sx={{ overflowY: "scroll" }}>
                                        <Box width="100%" position='relative' >
                                            <Skeleton sx={{ display: isProjectPreviewLoading ? "block" : "none", bgcolor: "#2F2F2F" }} variant="rectangular" width="100%" height='50vh' />
                                            <Box sx={{ display: isProjectPreviewLoading ? "none" : "block" }}>
                                                {

                                                    projectClicked.projectPreviewVideo ? <video onLoadedData={() => setisProjectPreviewLoading(false)} width="100%" src={projectVidUrl} autoPlay={true} loop muted></video> : <img onLoad={() => setisProjectPreviewLoading(false)} width="100%" src={projectThumbUrl} alt="img" />
                                                }
                                            </Box>

                                            <Box sx={{ background: "linear-gradient(0deg,#181818,transparent 50%)" }} width="100%" height="100%" position="absolute" bottom='0'></Box>
                                            <Box sx={{ position: "absolute", top: 0, right: 0, }}>
                                                <Button onClick={closeProject} variant='contained' color='secondary' sx={{ borderRadius: "50%", mt: 1.4, mr: 1.4, minWidth: "40px !important", height: "40px !important", width: "40px !important" }} size='small' > <CloseIcon sx={{ fontSize: "23px", color: "white" }} /> </Button>
                                            </Box>
                                        </Box>
                                        <Box sx={{ px: { xs: 1.5, md: 3 }, py: { xs: 3, md: 3 } }}>
                                            <Box>
                                                <Typography variant='h1' sx={{ fontSize: { xs: 26, md: 32 } }} color="#fff" fontWeight={600} >{projectClicked.title}</Typography>
                                                <Typography mt={0.4} sx={{ fontSize: { xs: 14, md: 16 } }} textTransform='uppercase' variant="subtitle1" color="#999999" fontWeight={600} >{projectClicked.project_about}</Typography>
                                            </Box>
                                            <Stack mt={2} spacing={1.2}>
                                                <List >
                                                    <ListItem sx={{ padding: "0 !important", mb: "10px" }}>
                                                        <ListItemIcon sx={{ minWidth: "auto !important", mr: 1.2 }}>
                                                            <CategoryIcon sx={{ color: "#ff792e", fontSize: { xs: 22, md: 24 } }} />
                                                        </ListItemIcon>
                                                        <ListItemText
                                                            primary={
                                                                <>
                                                                    <Stack direction='row' spacing={1}>
                                                                        <Typography variant="subtitle1" color="#fcf6f4" sx={{ fontSize: { xs: 14, md: 16 } }}>Category - </Typography>
                                                                        <Typography variant="subtitle1" color="#bcbcbc" sx={{ fontSize: { xs: 14, md: 16 } }}>{projectClicked.project_type}</Typography>
                                                                    </Stack>
                                                                </>
                                                            }
                                                        />
                                                    </ListItem>
                                                    <ListItem sx={{ padding: "0 !important", mb: "10px", alignItems: { xs: "start", md: "center" }, py: { xs: "4px !important", md: "0 !important" } }}>
                                                        <ListItemIcon sx={{ minWidth: "auto !important", mr: 1.2 }}>
                                                            <LayersIcon sx={{ color: "#ff792e", fontSize: { xs: 22, md: 24 } }} />
                                                        </ListItemIcon>
                                                        <ListItemText
                                                            sx={{ my: { xs: 0, md: "4px" } }}
                                                            primary={
                                                                <>
                                                                    <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'start', width: '100%' }}>
                                                                        <Typography variant="subtitle1" color="#fcf6f4" sx={{ fontSize: { xs: 14, md: 16 } }}>
                                                                            Tech Stack -
                                                                        </Typography>
                                                                        <Typography variant="subtitle1" color="#bcbcbc" sx={{ fontSize: { xs: 14, md: 16 }, flex: 1, marginLeft: '8px' }}>
                                                                            {projectClicked.tools}
                                                                        </Typography>
                                                                    </div>
                                                                </>
                                                            }
                                                        />
                                                    </ListItem>
                                                    <ListItem sx={{ padding: "0 !important", mb: "10px" }}>
                                                        <ListItemIcon sx={{ minWidth: "auto !important", mr: 1.2 }}>
                                                            <DateRangeIcon sx={{ color: "#ff792e", fontSize: { xs: 22, md: 24 } }} />
                                                        </ListItemIcon>
                                                        <ListItemText
                                                            primary={
                                                                <>
                                                                    <Stack direction='row' spacing={1}>
                                                                        <Typography variant="subtitle1" color="#fcf6f4" sx={{ fontSize: { xs: 14, md: 16 } }}>Date - </Typography>
                                                                        <Typography variant="subtitle1" color="#bcbcbc" sx={{ fontSize: { xs: 14, md: 16 } }}>{projectClicked.date}</Typography>
                                                                    </Stack>
                                                                </>
                                                            }
                                                        />
                                                    </ListItem>
                                                    <ListItem sx={{ padding: "0 !important", mb: "10px" }}>
                                                        <ListItemIcon sx={{ minWidth: "auto !important", mr: 1.2 }}>
                                                            <PersonIcon sx={{ color: "#ff792e", fontSize: { xs: 22, md: 24 } }} />
                                                        </ListItemIcon>
                                                        <ListItemText
                                                            primary={
                                                                <>
                                                                    <Stack direction='row' spacing={1}>
                                                                        <Typography variant="subtitle1" color="#fcf6f4" sx={{ fontSize: { xs: 14, md: 16 } }}>Client - </Typography>
                                                                        <Typography variant="subtitle1" color="#bcbcbc" sx={{ fontSize: { xs: 14, md: 16 } }}>{projectClicked.client ? projectClicked.client : "N/A"}</Typography>
                                                                    </Stack>
                                                                </>
                                                            }
                                                        />
                                                    </ListItem>
                                                    <ListItem sx={{ padding: "0 !important", mb: "10px" }}>
                                                        <ListItemIcon sx={{ minWidth: "auto !important", mr: 1.2 }}>
                                                            <PhoneAndroidIcon sx={{ color: "#ff792e", fontSize: { xs: 22, md: 24 } }} />
                                                        </ListItemIcon>
                                                        <ListItemText
                                                            primary={
                                                                <>
                                                                    <Stack direction='row' spacing={1}>
                                                                        <Typography variant="subtitle1" color="#fcf6f4" sx={{ fontSize: { xs: 14, md: 16 } }}>Responsive</Typography>
                                                                    </Stack>
                                                                </>
                                                            }
                                                        />
                                                    </ListItem>
                                                    <ListItem sx={{ padding: "0 !important", mb: "10px" }}>
                                                        <ListItemIcon sx={{ minWidth: "auto !important", mr: 1.2 }}>
                                                            <LanguageIcon sx={{ color: "#ff792e", fontSize: { xs: 22, md: 24 } }} />
                                                        </ListItemIcon>
                                                        <ListItemText
                                                            primary={
                                                                <>
                                                                    <Stack component="span" direction='row' spacing={1}>
                                                                        <Typography variant="subtitle1" color="#fcf6f4" sx={{ fontSize: { xs: 14, md: 16 } }}>Visit site - </Typography>

                                                                        <a style={{ textDecoration: "none", display: "flex", justifyContent: "center", alignItems: "center" }} href={projectClicked.websiteLink ? projectClicked.websiteLink : "#"} target='_blank'>
                                                                            <Box sx={{ textDecoration: "underline", fontSize: { xs: 14, md: 16 } }} display='flex' justifyContent='center' alignItems='center' variant="subtitle1" color={projectClicked.websiteLink ? "#ff792e" : "#777"} >{projectClicked.websiteName}</Box>
                                                                        </a>
                                                                        {
                                                                            projectClicked.websiteLink ? null : (

                                                                                <Stack sx={{ ml: "19px !important", display: { xs: "none", md: "flex" } }} direction='row' justifyContent='center' alignItems='center' spacing={1} >
                                                                                    <InfoIcon sx={{ color: "#696969", fontSize: { xs: 14, md: 16 } }} />
                                                                                    <Typography sx={{ color: "#696969", fontSize: { xs: 14, md: 16 } }}>This link is currently not live</Typography>
                                                                                </Stack>
                                                                            )
                                                                        }
                                                                    </Stack>
                                                                </>
                                                            }
                                                            secondary={
                                                                <>
                                                                    {
                                                                        projectClicked.websiteLink ? null : (

                                                                            <Stack component="span" sx={{ ml: "0px !important", display: { xs: "flex", md: "none" } }} direction='row' justifyContent='start' alignItems='center' spacing={0.3} >
                                                                                <InfoIcon sx={{ color: "#696969", fontSize: { xs: 12, md: 16 } }} />
                                                                                <Typography sx={{ color: "#696969", fontSize: { xs: 12, md: 16 } }}>This link is currently not live</Typography>
                                                                            </Stack>
                                                                        )
                                                                    }
                                                                </>
                                                            }
                                                        />
                                                    </ListItem>
                                                    <ListItem sx={{ padding: "0 !important" }}>
                                                        <ListItemIcon sx={{ minWidth: "auto !important", mr: 1.2 }}>
                                                            <GitHubIcon sx={{ color: "#ff792e", fontSize: { xs: 22, md: 24 } }} />
                                                        </ListItemIcon>
                                                        <ListItemText
                                                            primary={
                                                                <>
                                                                    <Stack component="span" direction='row' spacing={1}>
                                                                        <Typography variant="subtitle1" color="#fcf6f4" sx={{ fontSize: { xs: 14, md: 16 } }}>Git Repo - </Typography>

                                                                        <a style={{ textDecoration: "none", display: "flex", justifyContent: "center", alignItems: "center" }} href={projectClicked.gitRepoLink ? projectClicked.gitRepoLink : "#"} target='_blank'>
                                                                            <Box sx={{ textDecoration: "underline", fontSize: { xs: 14, md: 16 } }} display='flex' justifyContent='center' alignItems='center' variant="subtitle1" color={projectClicked.gitRepoLink ? "#ff792e" : "#777"} >{projectClicked.gitRepoName}</Box>
                                                                        </a>
                                                                        {
                                                                            projectClicked.gitRepoLink ? null : (

                                                                                <Stack sx={{ ml: "19px !important", display: { xs: "none", md: "flex" } }} direction='row' justifyContent='center' alignItems='center' spacing={1} >
                                                                                    <InfoIcon sx={{ color: "#696969", fontSize: { xs: 14, md: 16 } }} />
                                                                                    <Typography sx={{ color: "#696969", fontSize: { xs: 14, md: 16 } }}>This link is currently not live</Typography>
                                                                                </Stack>
                                                                            )
                                                                        }
                                                                    </Stack>
                                                                </>
                                                            }
                                                            secondary={
                                                                <>
                                                                    {
                                                                        projectClicked.gitRepoLink ? null : (

                                                                            <Stack component="span" sx={{ ml: "0px !important", display: { xs: "flex", md: "none" } }} direction='row' justifyContent='start' alignItems='center' spacing={0.3} >
                                                                                <InfoIcon sx={{ color: "#696969", fontSize: { xs: 12, md: 16 } }} />
                                                                                <Typography sx={{ color: "#696969", fontSize: { xs: 12, md: 16 } }}>This link is currently not live</Typography>
                                                                            </Stack>
                                                                        )
                                                                    }
                                                                </>
                                                            }
                                                        />
                                                    </ListItem>
                                                </List>
                                            </Stack>
                                            <Box mt={3}>
                                                <Typography variant='body1' color='#fff' sx={{ fontSize: { xs: 14, md: 16 }, textAlign: "justify" }}>

                                                    {projectClicked.desciption ? projectClicked.desciption.split("<br>").map((paragraph, index) => {

                                                        return <p key={index}>{paragraph}</p>
                                                    }
                                                    ) : ""}
                                                </Typography>
                                            </Box>
                                            <div className="downloadResumeBtn" onClick={() => openGallery(projectClicked.project_images)} >
                                                <span className="btnBG"></span>
                                                <p>view site</p>
                                            </div>
                                        </Box>
                                    </Grid>
                                </Grid>


                                <div>                                {/* ==================================================================================================PHN============================================================================*/}

                                    <div className="phoneProjects">
                                        {
                                            filteredProjects.slice(0, projectNumbers).map((project, index) => {
                                                const ipRemovedUrl = new URL(project.thumbPoster).pathname
                                                const redUrl = '/redapi' + ipRemovedUrl

                                                return (
                                                    loading ? (
                                                        <Skeleton key={project.id} sx={{ bgcolor: "#2F2F2F", borderRadius: "12px" }} variant="rounded" width="100%" height='220px' />
                                                    ) : (
                                                        <div key={project.id}>
                                                            <Skeleton sx={{ display: (loading || imageLoading[index]) ? "block" : "none", bgcolor: "#2F2F2F", borderRadius: "12px" }} variant="rounded" width="100%" height='220px' />
                                                            <div style={{ display: (loading || imageLoading[index]) ? "none" : "block" }} className="phnSingleproject" onClick={() => openingProject(project, project.id)} >
                                                                <div className="image">
                                                                    <img src={redUrl} style={{ opacity: (IsPlayPreview && hoverId == project.id) && 0 }} alt="img" />
                                                                    <div className="overlay"><i className="fas fa-plus"></i></div>
                                                                </div>
                                                                <h1>{project.title}</h1>

                                                            </div>
                                                        </div>
                                                    )
                                                )
                                            })
                                        }
                                    </div>
                                    {
                                        HideMore ? null : (
                                            <p onClick={() => showMore()} className='moreOption'>More Projects👇</p>
                                        )
                                    }
                                </div>
                                {/* ==================================================================================================PHN============================================================================*/}


                            </div>

                        </div>

                        <Footer />
                    </section >





                    <div className="projectImagesSection" style={{ opacity: opengallery && 1, visibility: opengallery && "visible" }}>
                        <i className="fas fa-times" onClick={() => falsefunc()}></i>
                        <div className="projectImgslider">
                            <div className="gallerymainHeading">
                                <h1>Image Gallery</h1>
                                <div className="underline">
                                    <span className="circle"></span>
                                    <span className="line"></span>
                                </div>
                            </div>

                            <span style={{ opacity: !ImageLoader && 0, visibility: !ImageLoader && "hidden", position: "fixed", top: "50%", left: "50%", transform: "translate(-50%, -50%)", zIndex: 1, transition: "all 0.3s ease-in-out" }} className="imagePreloader">
                                <PulseLoader color="#ff792e" />
                            </span>

                            <Slider {...settings}>
                                {
                                    galleryArr.map((img, index) => {
                                        const ipRemovedUrl = new URL(img.image).pathname
                                        const redUrl = '/redapi' + ipRemovedUrl

                                        return (
                                            <div className="projectImg" key={index}>
                                                {opengallery ? <img src={redUrl} alt="img" style={displayImg} onLoad={imageLoaded} /> : null}
                                            </div>
                                        )

                                    })
                                }
                            </Slider>
                        </div>
                    </div>

                    <div className="rotationWheel">
                        <i ref={wheelRef} className="fas fa-yin-yang"></i>
                    </div>
                </div >
            </ThemeProvider >
        </>
    )
}

export default Work;